// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3eMYj","info":"PatientInfo_info__33Y0t"};